export const itemFieldTypes = [
  { value: 'text', label: 'Text' },
  { value: 'number', label: 'Number' },
  { value: 'currency', label: 'Currency' },
  { value: 'select', label: 'Dropdown' },
  { value: 'textarea', label: 'Notes' },
  { value: 'checkbox', label: 'Checkbox' },
  { value: 'date', label: 'Date' },
];

export const itemCurrencySymbols = ['R', '$', '€', '£'];

export const normaliseItemCurrencySymbol = (symbol) => (
  itemCurrencySymbols.includes(symbol) ? symbol : 'R'
);

export const itemFormPresets = [
  {
    id: 'stock-taking',
    label: 'Stock taking',
    title: 'Stock take',
    submitLabel: 'Submit stock take',
    itemFields: [
      { id: 'countedQuantity', label: 'Counted quantity', type: 'number', required: true, placeholder: '0' },
      { id: 'status', label: 'Status', type: 'select', required: true, options: ['In stock', 'Low stock', 'Missing', 'Damaged'] },
      { id: 'notes', label: 'Notes', type: 'textarea', required: false, placeholder: 'Condition, location, or follow-up' },
    ],
  },
  {
    id: 'item-management',
    label: 'Item management',
    title: 'Item management',
    submitLabel: 'Save item updates',
    itemFields: [
      { id: 'status', label: 'Status', type: 'select', required: true, options: ['Available', 'Reserved', 'Archived', 'Needs attention'] },
      { id: 'assignee', label: 'Assignee', type: 'text', required: false, placeholder: 'Team member' },
      { id: 'notes', label: 'Notes', type: 'textarea', required: false, placeholder: 'Internal notes' },
    ],
  },
  {
    id: 'item-booking',
    label: 'Item booking',
    title: 'Item booking',
    submitLabel: 'Submit booking',
    itemFields: [
      { id: 'quantity', label: 'Quantity', type: 'number', required: true, placeholder: '1' },
      { id: 'date', label: 'Booking date', type: 'date', required: true },
      { id: 'status', label: 'Status', type: 'select', required: true, options: ['Requested', 'Confirmed', 'Unavailable'] },
      { id: 'notes', label: 'Notes', type: 'textarea', required: false, placeholder: 'Booking details' },
    ],
  },
  {
    id: 'ordering',
    label: 'Ordering',
    title: 'Ordering',
    submitLabel: 'Submit order',
    itemFields: [
      { id: 'orderedQuantity', label: 'Ordered quantity', type: 'number', required: true, placeholder: '0' },
      { id: 'unitCost', label: 'Unit cost', type: 'currency', required: false, currencySymbol: 'R', readOnly: true, placeholder: '0.00' },
      { id: 'itemTotal', label: 'Item total', type: 'currency', required: false, currencySymbol: 'R', readOnly: true, placeholder: '0.00' },
    ],
  },
];

const orderingOrderFieldIds = new Set(['requiredBy', 'status', 'notes']);

export const createItemFormField = (count) => ({
  id: `item-field-${Date.now()}-${count}`,
  label: 'New item field',
  type: 'text',
  currencySymbol: 'R',
  required: false,
  placeholder: '',
  options: ['Option 1', 'Option 2'],
});

export const createItemFormFromPreset = (presetId = 'stock-taking', count = 1) => {
  const preset = itemFormPresets.find((item) => item.id === presetId) || itemFormPresets[0];
  return {
    id: `item-form-${Date.now()}-${count}`,
    enabled: true,
    preset: preset.id,
    title: preset.title,
    buttonText: preset.label,
    submitLabel: preset.submitLabel,
    itemFields: preset.itemFields.map((field) => ({ ...field })),
  };
};

export const createCustomItemForm = (count = 1) => ({
  id: `item-form-${Date.now()}-${count}`,
  enabled: true,
  preset: 'custom',
  title: `Custom item form ${count}`,
  buttonText: 'Item form',
  submitLabel: 'Submit item form',
  itemFields: [],
});

const fieldsForPreset = (form = {}) => {
  const preset = itemFormPresets.find((item) => item.id === form.preset);
  if (!preset) return Array.isArray(form.itemFields) ? form.itemFields : [];

  const savedFields = Array.isArray(form.itemFields)
    ? form.itemFields.filter((field) => form.preset !== 'ordering' || !orderingOrderFieldIds.has(field.id))
    : [];
  const savedFieldIds = new Set(savedFields.map((field) => field.id));
  const missingPresetFields = preset.itemFields.filter((field) => !savedFieldIds.has(field.id));
  return [...savedFields, ...missingPresetFields.map((field) => ({ ...field }))];
};

export const normaliseItemForms = (forms = []) => (
  Array.isArray(forms) ? forms.map((form) => ({
    ...form,
    enabled: form.enabled !== false,
    itemFields: fieldsForPreset(form).map((field) => ({
      ...field,
      currencySymbol: normaliseItemCurrencySymbol(field.currencySymbol),
    })),
  })) : []
);
